import { useNavigate, useOutletContext, useParams } from 'react-router-dom'

import Loading from 'modules/core/components/Loading'
import NotFound from 'modules/core/components/NotFound'

import { EditGroup } from 'modules/expenses/components/groups/Edit'
import { useGroupDetail } from 'modules/expenses/hooks/useGroupDetail'
import { RouteContextParams } from 'modules/expenses/lib/RouteContextParams'

const GroupEditPage = () => {
  const navigate = useNavigate()
  const { groupId } = useParams()
  const { back } = useOutletContext<RouteContextParams>()

  const { group, loading } = useGroupDetail({ id: Number(groupId), includeAttachments: true })

  if (loading) return <Loading inline />
  if (!group) return <NotFound />

  return <EditGroup group={group} onClose={() => navigate(back.href)} />
}

export default GroupEditPage
